import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Navigate, NavLink, redirect, useNavigate, } from 'react-router-dom';



import axios from 'axios';
import { useState,useEffect } from 'react';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        MyStore
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignIn(props) {

  const[username,setUsername]=useState()
  const[password,setPassword]=useState()
 const navigate = useNavigate()


  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setUsername(data.get('email'))
    setPassword(data.get('password'))
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
    fetchData();
   
  };


//    const username= kminchelle
//  const password=0lelplR

 

const msg = ''

function fetchData(){

fetch('https://dummyjson.com/auth/login', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    
    username:username,
    password: password,
    // expiresInMins: 60, // optional
  })
})
.then(res => res.json())
.then(((res)=>{console.log(res);
                console.log(res.message);
               userInfo(res);
               Auth(res.message);
                 }))



}

function userInfo(res){
  localStorage.setItem('username',res.username)
  localStorage.setItem('email',res.email)
  localStorage.setItem('firstName',res.firstName)
  localStorage.setItem('lastName',res.lastName)
}


function Auth(msg){
   if(msg=='Invalid credentials'){
    alert('wrong');
   }
   else{
    props.setlogged(true)
    localStorage.setItem('log','true')

    
     navigate('/')
   }
}


useEffect(()=>{
  // ()=>  navigate('/')
  // fetchData();

},[])


  return (

  
    <ThemeProvider theme={theme}>
    
      <Container component="main" maxWidth="sm" >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
              <NavLink to="/SignUp">
           Don't have account ,Sign Up
          </NavLink>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
      <Typography>  username: kminchelle
  // password: 0lelplR</Typography>
    </ThemeProvider>
  );
}